//!#system	

//!#system	

<template>
	<div>
		<iframe 
			class="iframe-placeholder" 
			:src="iframeSrc" 
			ref="uploader" 
			width="100%"
			height="104" 
			frameBorder="0"
			style="overflow:hidden;"
			scrolling="no"
		/>
	</div>
</template>

<script>
import tools from '@/tools';
export default {
	name: 'ApplicationFile',
	props: {
		routeInfo: {
			type: Object,
			required: true
		},
		value: { // parent object that contains this field
			type: Object,
			default: () => {}
		},
		context: { // Create, update, or filter
			type: String
		},
		fieldName: {
			type: String,
			required: true
		},
		fieldInfo: {
			type: Object,
			required: true
		},
		isBase: {
			type: Boolean,
			default: false
		},
		fieldIndex: {
			type: Number,
			default: -1
		},
		parent: { //parent of the parent
			type: Object,
			default: () => {}
		},
		parentKey: {
			type: String,
			default: ''
		},
		memo: {
			type: String,
			default: ''
		},
		accept: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			model: this.value
		}
	},
	computed: {
		iframeSrc() {
			return '/ui/uploader.html?memo=' + encodeURIComponent(this.memo || this.fieldName)
		}
	},
	mounted() {
		window.onmessage = (e) => {
			console.log('ApplicationFile', 'onmessage', e.data);
			if (e.data.file_ref) {
				this.model['id'] = e.data.file_ref;
				if (this.parentKey && tools.isPojo(this.parent) && Object.keys(this.parent).length > 0 && tools.toIdField(this.parentKey) in this.parent) {
					// bubble up the id to the parent
					this.parent[tools.toIdField(this.parentKey)] = e.data.file_ref;
				}
				this.$emit('input', this.model);
			}
		}
	}
}
</script>

<style>
.iframe-placeholder
{
   background: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 100% 100%"><text fill="%23FF0000" x="50%" y="50%" font-family="\'Lucida Grande\', sans-serif" font-size="12" text-anchor="middle">LOADING...</text></svg>') 0px 0px no-repeat;
}
</style>